import React, { useContext, useState, Fragment } from 'react';
import { Pressable, Text, View, Dimensions } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faEdit } from '@fortawesome/free-solid-svg-icons';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
  Button,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import {
  TAGS_WITH_COUNT,
  CREATE_TAG,
  UPDATE_TAG
} from './queries';
import SubNav from './SubNav';
import NewBlog from './new';
import EditBlog from './edit';
import Card from './Card';

import {
  BlogContainer,
  CardContainer
} from './elements';
import { elRed } from '../../styles/colors';

const inputStyle = {
  marginBottom: '10px'
}

const dimensions = Dimensions.get('window');
const smallScreen = dimensions.width < 800;

const Tags = ({ setShowModal }) => {
  const [showAddTagModal, setShowAddTagModal] = useState();
  const [showEditModal, setShowEditModal] = useState();
  const [newTag, setNewTag] = useState('');
  const [editTag, setEditTag] = useState();
  const [updatedName, setUpdatedName] = useState('');

  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const [createTag] = useMutation(CREATE_TAG, {
    onCompleted: (response) => {
      setNewTag('');
      if(refetch) {
        refetch();
      }
    }
  });

  const [updateTag] = useMutation(UPDATE_TAG, {
    onCompleted: (response) => {
      setEditTag('');
      setUpdatedName('');
      if(refetch) {
        refetch();
      }
    }
  });

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const { data } = useQuery(TAGS_WITH_COUNT,
    { variables: queryVariables }
  );

  // const [hideBankAccount] = useMutation(HIDE_BANK_ACCOUNT, { onCompleted: refetch });

  // if (!data) { return <DataState.Loading /> };

  // const onHide = bankAccount => {
  //   if (window.confirm(`Hide ${bankAccount.accountName}?`)) {
  //     hideBankAccount({ variables: { id: bankAccount.id }});
  //   }
  // };

  const columns = [
    {
      key: 'name',
      label: 'Tag Name',
      entry: ({ entry }) => entry.name,
      sort: 'asc',
      content: ({ entry }) => {
        return (
          entry === editTag ?
            <View style={{display: 'flex', flexDirection: 'row'}}>
              <input
                type={'text'}
                onChange={(e) => setUpdatedName(e.target.value)}
                value={updatedName || entry.name}
              />
              <Pressable
                onPress={() => {
                  if(editTag !== '' && updatedName !== '') {
                    updateTag({variables: {id: entry.id, name: updatedName}})
                  }else {
                    setEditTag('');
                    setUpdatedName('');
                  }
                }}
              >
                <Text style={{marginTop: '5px', marginBottom: '5px', marginLeft: '10px'}}>
                  <FontAwesomeIcon
                    icon={faEdit} title="Create Tag"
                    style={{color: elRed, marginRight: '5px'}}
                  />Update Tag
                </Text>
              </Pressable>
            </View>
            :
            entry.name
        )
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setEditTag(entry)}>
            <Text>Edit</Text>
          </Pressable>
          <LinkSpace />
            {/* <Pressable onPress={() => onHide(entry)} >
              <Text>{entry.hiddenAt ? 'UnHide' : 'Hide'}</Text>
            </Pressable> */}
        </LinkContainer>
      )
    },
  ];

  // const buttons = (
  //   <View style={{display: 'flex', flexDirection: 'row'}}>
  //     <Filter
  //       clearFilters={() => {
  //         setFilters({})
  //         setShowModal(false)
  //       }}
  //       filters={filters}
  //       setFilters={setFilters}
  //     >
  //     </Filter>
  //     <ResetSettings />
  //   </View>
  // );

  return (
    <MainContainer>

      <ContentContainer>
        <PageTitle>Blog Categories</PageTitle>
        <View style={{display: 'flex', flexDirection: 'row'}}>
          <input
            type={'text'}
            onChange={(e) => setNewTag(e.target.value)}
            value={newTag}
          />
          <Pressable
            onPress={() => {if(newTag !== '') createTag({variables: {name: newTag}})}}
          >
            <Text style={{marginTop: '5px', marginBottom: '5px', marginLeft: '10px'}}>
              <FontAwesomeIcon
                icon={faCirclePlus} title="Create Tag"
                style={{color: elRed, marginRight: '5px'}}
              />Create Category
            </Text>
          </Pressable>
        </View>
        <View style={{maxWidth: smallScreen ? '75%' : '100%'}}>
          <DataTable.Gql
            setRefetch={setRefetch}
            query={TAGS_WITH_COUNT}
            queryName='tagsWithCount'
            queryVariables={queryVariables}
            columns={columns}
            pageLength={25}
            // buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.tagsWithCount)}
            htmlTable
          />
        </View>

      </ContentContainer>

      {/* {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Blog"
        >
          <EditBankAccount
            setShowModal={setShowEditModal}
            refetch={refetch}
            // selects={data}
          />
        </Modal>
      } */}
    </MainContainer>
  );
};

export default Tags;
